import { Injectable } from '@angular/core';
import { CountriesState } from '@core/states/countries.state';
import countries from '@core/static-assets/countries';
import { Region } from '@core/typings/location.typing';
import { AttachYCState, BaseYCService } from '@yourcause/common/state';

@AttachYCState(CountriesState)
@Injectable({ providedIn: 'root' })
export class CountriesService extends BaseYCService<CountriesState> {
  get countries () {
    return this.get('countries');
  }

  get regions () {
    return this.get('regions');
  }

  setCountries () {
    if (!this.countries) {
      this.set('countries', countries);
    }
  }

  setRegions (regions: {
    [countryName: string]: Region[];
  }) {
    this.set('regions', regions);
  }
}
